import { useEffect, useState } from "react";

const useTheme = () => {
  const getInitialTheme = () => {
    return (
      localStorage.getItem("theme") ||
      document.documentElement.getAttribute("data-theme")
    );
  };

  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    const element = document.documentElement;

    element.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);

    const updateTheme = () => {
      const currentTheme = element.getAttribute("data-theme");
      setTheme(currentTheme);
    };

    const observer = new MutationObserver(() => {
      updateTheme();
    });

    observer.observe(element, {
      attributes: true,
      attributeFilter: ["data-theme"]
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return theme;
};

export default useTheme;
